export default {
    namespaced: true,
    state: () => ({
        item: null
    }),
    mutations: {
        setItems(state, items) {
            state.item = null;
            for (let item of items) {
                if (item.type === `block`) {
                    item.block = window.cmsFactory.new(item.block);
                    state.item = item;
                    break;
                }
            }

            console.log(`Updated Clipboard`, state.item);
        }
    },
    actions: {
        /**
         * Content must be an array of ClipboardItem
         * @param state
         * @param commit
         * @param items {Array}
         * @returns {Promise<void>}
         */
        async writeClipboard({state, commit}, items) {
            commit(`setItems`, items);
            let clipboardItems = [];
            for (let i = 0; i < items.length; i++) {
                clipboardItems.push(new ClipboardItem({
                    "text/plain": JSON.stringify(items[i])
                }));
            }
            await navigator.clipboard.write(clipboardItems);
        },
        async readClipboard({state, commit}) {
            // disabled on firefox locally
            if (window.location.href.indexOf(`localhost`) > 0 && navigator.userAgent.toLowerCase().indexOf(`firefox`) > -1) {
                return;
            }
            let items;
            try {
                items = await navigator.clipboard.read();
            } catch (e) {
                // clipboard permission denied or document not focused: nothing to read
                return;
            }
            const validItems = [];
            for (let clipboardItem of items) {
                // getType throws NotFoundError when the copied content has no plain text (image, file...)
                if (!clipboardItem.types.includes(`text/plain`))
                    continue;

                try {
                    const blob = await clipboardItem.getType(`text/plain`);
                    if (!blob)
                        continue;

                    const text = await blob.text();
                    if (!text.startsWith(`{`))
                        continue;

                    const item = JSON.parse(text);
                    if (item.source === `eye-in-cms`) {
                        validItems.push(item);
                    }
                } catch (e) {
                    console.error(e);
                }
            }
            if (validItems.length > 0) {
                commit(`setItems`, validItems);
            }
        }
    }
}
